import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';

/**
 * Flips to `true` once the main thread is idle (or after `timeoutMs`, whichever comes first).
 * Starts `false` on both server and client, so there's no hydration mismatch. Useful for
 * deferring non-critical work (e.g. loading an autoplay video) past the initial render.
 */
export const useIdleFlag = t0 => {
  const $ = _c(3);
  const timeoutMs = t0 === undefined ? 2500 : t0;
  const [isIdle, setIsIdle] = useState(false);
  let t1;
  let t2;
  if ($[0] !== timeoutMs) {
    t1 = () => {
      if (typeof requestIdleCallback === "function") {
        const id = requestIdleCallback(() => setIsIdle(true), {
          timeout: timeoutMs
        });
        return () => cancelIdleCallback(id);
      }
      if (document.readyState === "complete") {
        setIsIdle(true);
        return;
      }
      const handleLoad = () => setIsIdle(true);
      window.addEventListener("load", handleLoad, {
        once: true
      });
      const timeoutId = setTimeout(() => setIsIdle(true), timeoutMs);
      return () => {
        window.removeEventListener("load", handleLoad);
        clearTimeout(timeoutId);
      };
    };
    t2 = [timeoutMs];
    $[0] = timeoutMs;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return isIdle;
};